export class Expiry {

  public expiryInMinutes: number;

  constructor(expiryInMinutes: number) {
    this.expiryInMinutes = expiryInMinutes;
  }

}
